import _ from 'lodash';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { MdbTabsComponent } from 'mdb-angular-ui-kit/tabs';
import { MdbTabChange } from 'mdb-angular-ui-kit/tabs/tabs.component';
import { CampaignTabsStepService } from './campaign-tabs-step.service';
import { CampaignFormService } from './campaign-form.service';
import { CampaignOptionListService } from './campaign-option-list.service';
import { ToastService } from 'app/toast/services/toast.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignTabsService {
    private _status = false;
    set status(status: boolean) {
        this._status = status;
        this.campaignTabsStepService.status = status;
    }
    get status() {
        return this._status;
    }

    private _tabs: MdbTabsComponent = null;
    set tabs(tabs: MdbTabsComponent) {
        this._tabs = tabs || null;
        if(this._tabs == null) {
            this.status = false;
            return;
        }
        this.status = true;

        if(this.campaignTabsStepService.step > 0) {
            this.setActiveTab(this.campaignTabsStepService.step);
        }
    }
    get tabs(): MdbTabsComponent {
        return this._tabs;
    }

    set step(step: number) {
        this.campaignTabsStepService.step = step;
    }
    get step() {
        return this.campaignTabsStepService.step;
    }

    set firstStep(firstStep: number) {
        this.campaignTabsStepService.firstStep = firstStep;
    }
    get firstStep() {
        return this.campaignTabsStepService.firstStep;
    }

    set lastStep(lastStep: number) {
        this.campaignTabsStepService.lastStep = lastStep;
    }
    get lastStep() {
        return this.campaignTabsStepService.lastStep;
    }

    private errors = [];

    constructor(
        private store: Store,
        private campaignTabsStepService: CampaignTabsStepService,
        private campaignFormService: CampaignFormService,
        private campaignOptionListService: CampaignOptionListService,
        private toastService: ToastService
    ) {
        this.campaignTabsStepService.onPreviousStepSubject.subscribe(() => {
            this.previousStep();
        });
        this.campaignTabsStepService.onNextStepSubject.subscribe(() => {
            this.nextStep();
        });
    }

    onTabChange(event: MdbTabChange) {
        switch(event.index) {
          case 3:
          case 2:
            const { form, campaignTypeData } = this.campaignFormService;
            const { value: idValue } = form.get('id');
            const { value: hideCustomValue } = campaignTypeData.get('hideCustom') || { value: true };
            if(hideCustomValue) {
                if(this.campaignOptionListService.activeList.length < 1) {

                    this.errors.push(() => {
                        this.toastService.show('danger', 'Please add Campaign Option', {delay: 10000});
                    });

                    this.setActiveTab(1);
                    return;
                }
            } else {
                if(idValue === null) {

                    this.errors.push(function() {
                        this.toastService.show('danger', 'Campaign should be saved', {delay: 10000});
                    });

                    this.setActiveTab(this.step)
                    return;
                }
            }
          case 1:
            if(this.campaignFormService.form.invalid) {

              this.errors.push(function() {
                this.campaignFormService.isNotValid();
              });

              this.setActiveTab(0);

              return;
            }
          case 0:
            this.step = event.index;
        }

        if(event.index > this.lastStep){
            this.setActiveTab(this.step)
        }

        if(this.errors.length > 0) {
            const error = this.errors.pop();
            error.call(this);
            this.errors = [];
        }

        return;
    }

    setActiveTab(index: number) {
        if(this.status) {
            this._tabs.setActiveTab(index);
            this.step = index;
        }
    }

    previousStep() {
        if(this.step > this.firstStep) {
            return this.setActiveTab(this.step - 1);
        }
        return null;
    }

    nextStep() {
        if(this.step < this.lastStep) {
          return this.setActiveTab(this.step + 1);
        }
        return null;
    }

    reset() {
        this.status = false;

        this._tabs = null;

        this.campaignTabsStepService.reset();
    }
}
